// frontend/src/App.js — Session 18
// Routes ajoutées: /forgot-password + /reset-password
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './utils/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

import Login          from './pages/Login';
import Register       from './pages/Register';
import { ForgotPassword, ResetPassword } from './pages/ForgotPassword';

import Dashboard      from './pages/Dashboard';
import Devis          from './pages/Devis';
import Factures       from './pages/Factures';
import Clients        from './pages/Clients';
import Collaborateurs from './pages/Collaborateurs';
import Produits       from './pages/Produits';
import Prestations    from './pages/Prestations';
import Paiements      from './pages/Paiements';
import Notifications  from './pages/Notifications';
import FacturesPro    from './pages/FacturesPro';
import Demandes       from './pages/Demandes';
import Candidats      from './pages/Candidats';
import NotesCredit    from './pages/NotesCredit';
import NotesFrais     from './pages/NotesFrais';

const Deplacements = React.lazy(() => import('./pages/Deplacements'));
const TVA = React.lazy(() => import('./pages/TVA'));

const Courriers = React.lazy(() => import('./pages/Courriers'));

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/"                  element={<Login />} />
          <Route path="/login"             element={<Login />} />
          <Route path="/register"          element={<Register />} />
          <Route path="/forgot-password"   element={<ForgotPassword />} />
          <Route path="/reset-password"    element={<ResetPassword />} />

          {/* Routes protégées */}
          <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route path="/dashboard"      element={<Dashboard />} />
            <Route path="/devis"          element={<Devis />} />
            <Route path="/factures"       element={<Factures />} />
            <Route path="/notes-credit"   element={<NotesCredit />} />
            <Route path="/clients"        element={<Clients />} />
            <Route path="/collaborateurs" element={<Collaborateurs />} />
            <Route path="/produits"       element={<Produits />} />
            <Route path="/prestations"    element={<Prestations />} />
            <Route path="/paiements"      element={<Paiements />} />
            <Route path="/notifications"  element={<Notifications />} />
            <Route path="/facturespro"    element={<FacturesPro />} />
            <Route path="/demandes"       element={<Demandes />} />
            <Route path="/candidats"      element={<Candidats />} />
            <Route path="/notes-frais"     element={<NotesFrais />} />


<Route path="/deplacements" element={
  <React.Suspense fallback={<div style={{padding:20,color:'#888'}}>Chargement…</div>}>
    <Deplacements />
  </React.Suspense>
} />            
<Route path="/courriers" element={
  <React.Suspense fallback={<div style={{padding:20,color:'#888'}}>Chargement…</div>}>
    <Courriers />
  </React.Suspense>
} />
<Route path="/tva" element={
  <React.Suspense fallback={<div style={{padding:20,color:'#888'}}>Chargement…</div>}>
    <TVA />
  </React.Suspense>
} />
            
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
